import { render, staticRenderFns } from "./TypeAnswer.vue?vue&type=template&id=eae9926c"
import script from "./TypeAnswer.vue?vue&type=script&lang=js"
export * from "./TypeAnswer.vue?vue&type=script&lang=js"
import style0 from "./TypeAnswer.vue?vue&type=style&index=0&id=eae9926c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports